import { expoOut } from "svelte/easing";

// Count transition
export function highlight(
    node,
    {
        delay = 0,
        duration = 6000,
        easing = expoOut,
        r = 255,
        g = 255,
        b = 255,
        start = 1.2,
    }
) {
    const style = getComputedStyle(node);
    const transform = style.transform === "none" ? "" : style.transform;

    return {
        delay,
        duration,
        easing,
        css: (t) =>
            `background-color: rgba(${r},${g},${b},${1 - t * 1
            });transform: ${transform} scale(${Math.max(
                start - t * 0.5,
                1
            )});`,
    };
}
